module.exports = __webpack_public_path__ + "img/placeholder02.196a7035.png";